import { render } from "./AnimateurPage.vue?vue&type=template&id=9c57294c"
import script from "./AnimateurPage.vue?vue&type=script&lang=js"
export * from "./AnimateurPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__